
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Pourquoi installer un écran vitrine pour sa devanture ?",
    description:
      "Découvrez comment installer un écran dynamique dans votre vitrine peut booster votre visibilité. Attirez plus de clients avec des contenus interactifs et modernes.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
